import { useRef } from "react";
export const FileUploader = ({ handleFile, title }) => {
  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    handleFile(fileUploaded);
  };
  return (
    <>
      <button className="custom-btn w-350" onClick={handleClick}>
        <i className="fa fa-upload"></i>&nbsp;{title ? title:"Upload Photo"}
      </button>
      <input
        type="file"
        accept="application/jpg, application/png, application/jpeg, image/svg+xml"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }} 
      />
    </>
  );
};

export default FileUploader;
